import { useCallback, useEffect, useState } from "react";
import { useIdentity } from "../../../IdentityProvider";
import { getStoredWellbeingWorkflowId, setStoredWellbeingWorkflowId } from "./storage";

export const useWellbeingPreferences = () => {
  const { user } = useIdentity();
  const workspaceId = user.workspace?.id;

  const [selectedWorkflowId, setSelectedWorkflowId] = useState<string | undefined>(() =>
    getStoredWellbeingWorkflowId(workspaceId)
  );

  useEffect(() => {
    setSelectedWorkflowId(getStoredWellbeingWorkflowId(workspaceId));
  }, [workspaceId]);

  const setWorkflowPreference = useCallback(
    (workflowId: string | undefined) => {
      setSelectedWorkflowId(workflowId);
      setStoredWellbeingWorkflowId(workspaceId, workflowId);
    },
    [workspaceId]
  );

  return {
    selectedWorkflowId,
    setSelectedWorkflowId: setWorkflowPreference
  };
};
